import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { fetchBillingProcesses } from '../api/FetchBillingProcesses';

export function useBillingProcesses() {
  const { i18n } = useTranslation();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['billing-processes', i18n.language],
    queryFn: fetchBillingProcesses,
    staleTime: Infinity,
    select: (processes) =>
      [...processes].sort((a, b) =>
        a.label.localeCompare(b.label, i18n.language),
      ),
  });

  return { processes: data ?? [], isLoading, isError, refetch };
}
